module.exports = __webpack_public_path__ + "static/media/foto7.c7e824f4.JPG";